import {createSelector} from 'reselect';

const regions = state => state.common.regions || [];

const getRegions = createSelector(regions, (regions) => regions.map(region => region.name));

export default {
  getRegions,
};
